import createSelectors from './createSelectors';
import UsersGroup from '../models/UsersGroup';

const Select = createSelectors(UsersGroup, {});

export default Select;
